import React from 'react';
import api from '../../../api';
import { IGetNotificationRes } from '../../../types/api/notification/getNotification';

interface IFetchParams {
  residentId: number;
  from?: string | null;
  to?: string | null;
  sort?: string;
  limit?: number;
  notificationClass?: 0 | 1;
}

export const useFetchResidentNotifications = (
  residentId: number,
  shouldInitFetch: boolean = false, //初回fetchをするかどうか
  from: string | null = null,
  to: string | null = null,
  notificationClass: 0 | 1 = 0,
  sort = 'desc',
  limit = 10000
) => {
  const [notifications, setNotifications] = React.useState<IGetNotificationRes[]>();

  const fetchNotifications = async (
    from: string | null = null,
    to: string | null = null,
    notificationClass?: 0 | 1,
    sort = 'desc',
    limit = 10000
  ) => {
    const params: IFetchParams = {
      residentId,
      from,
      to,
      sort,
      limit,
      notificationClass,
    };

    if (!from) delete params.from;
    if (!to) delete params.to;
    if (!notificationClass) delete params.notificationClass;

    let result = await api.get('/residents/:residentId/notifications', {
      params,
    });

    setNotifications(result);
    return result;
  };

  React.useEffect(() => {
    if (!shouldInitFetch) return;
    fetchNotifications(from, to, notificationClass, sort, limit);
  }, []);

  return { residentNotifications: notifications, fetchResidentNotifications: fetchNotifications };
};
